export const shouldStripAccessibilityAttribute = (name: string) => name === 'role' || name.startsWith('aria-');

export const stripAccessibilityAttributes = (rootNode: ParentNode | Element | null | undefined) => {
    if (!rootNode || typeof (rootNode as ParentNode).querySelectorAll !== 'function') {
        return;
    }

    const stripElement = (element: Element) => {
        for (const attribute of Array.from(element.attributes)) {
            if (shouldStripAccessibilityAttribute(attribute.name)) {
                element.removeAttribute(attribute.name);
            }
        }
    };

    if (rootNode instanceof Element) {
        stripElement(rootNode);
    }

    for (const element of rootNode.querySelectorAll('*')) {
        stripElement(element);
    }
};

export const scrubAccessibilityMutationRecords = (records: MutationRecord[]) => {
    for (const record of records) {
        if (record.type === 'attributes') {
            if (record.target instanceof Element) {
                stripAccessibilityAttributes(record.target);
            }
            continue;
        }

        for (const node of Array.from(record.addedNodes)) {
            if (node instanceof Element || node instanceof DocumentFragment) {
                stripAccessibilityAttributes(node);
            }
        }
    }
};
